import { render, staticRenderFns } from "./InformationTable.vue?vue&type=template&id=5a923838&scoped=true&"
import script from "./InformationTable.vue?vue&type=script&lang=js&"
export * from "./InformationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a923838",
  null
  
)

export default component.exports